import React, { useState, useRef, useEffect } from "react";
import cx from "classnames";
import { cleanUpHTML } from '../../utils/utils';

const defaultState = {
    firstParagraph: '',
    body: '',
    moreTextDisplayed: false,
    hasMoreText: false,
};

const SeoTextBlock = ({ text, linesToDisplay, displayMoreText }) => {

    const [state, updateState] = useState(defaultState);
    const maskRef = useRef();
    const textRef = useRef();

    useEffect(() => {
        const formattedText = cleanUpHTML(text);
        const paragraphs = formattedText.match(/<p>(.*?)<\/p>/g) || [`<p>${formattedText}</p>`];
        const firstParagraph = paragraphs[0];
        const body = paragraphs.length > 1 ? formattedText.replace(firstParagraph, '') : '';
        const hasMoreText = (maskRef.current.clientHeight < textRef.current.clientHeight) || body;

        updateState({
            firstParagraph,
            body,
            hasMoreText,
            moreTextDisplayed: false,
        });
    }, [text]);

    const { hasMoreText, moreTextDisplayed, firstParagraph, body } = state;

    const maxHeight =
        linesToDisplay && !moreTextDisplayed ? `${Number(1.2 * linesToDisplay - 0.2)}em` : null;

    const styles = {
        maxHeight,
    };

    const classes = cx("seo-text-block__mask", {
        "seo-text-block__mask--expanded": moreTextDisplayed,
        "seo-text-block__mask--has-more": hasMoreText,
    });

    const seoBodyVisibility = cx("seo-text-block__body", {
        "seo-text-block__body--visible": moreTextDisplayed
    })

    return (
        <div className="seo-text-block">
            <div className={classes} ref={maskRef} style={styles}>
                <div className="seo-text-block__text" ref={textRef} dangerouslySetInnerHTML={{ __html: firstParagraph }} />
                <div className={seoBodyVisibility} dangerouslySetInnerHTML={{ __html: body }} />

            </div>
            {hasMoreText && (
                <footer className="seo-text-block__footer">
                    <button className="seo-text-block__link" onClick={() => updateState({ ...state, moreTextDisplayed: !moreTextDisplayed })}>
                        {!moreTextDisplayed ? displayMoreText : 'Show Less'}
                    </button>
                </footer>
            )}
        </div>
    );
};

export default SeoTextBlock;
